const REVIEWS = [
  { name: 'Ayesha Khan', country: 'Pakistan', avatar: 'https://i.pravatar.cc/100?img=5', rating: 5, text: 'From booking to lodging, everything was seamless. The winter special was unbelievable.' },
  { name: 'Daniel Lee', country: 'Singapore', avatar: 'https://i.pravatar.cc/100?img=15', rating: 5, text: 'Loved the curated experiences and the attention to detail. Will book again soon!' },
  { name: 'Sofia Garcia', country: 'Spain', avatar: 'https://i.pravatar.cc/100?img=32', rating: 4, text: 'Great value and easy itinerary. Customer support was responsive and kind.' },
  { name: 'Rahul Sharma', country: 'India', avatar: 'https://i.pravatar.cc/100?img=20', rating: 5, text: 'The Thailand package was a dream. Hotels and transfers were top-notch.' },
  { name: 'Mia Brown', country: 'UK', avatar: 'https://i.pravatar.cc/100?img=10', rating: 5, text: 'Beautiful UI, smooth process, and unforgettable trip memories.' },
  { name: 'Noah Wilson', country: 'Canada', avatar: 'https://i.pravatar.cc/100?img=26', rating: 4, text: 'Clean booking flow and great recommendations. Minor delay, but handled well.' }
];

function Stars({ n }) {
  return (
    <div className="flex gap-1" aria-label={`${n} star rating`}>
      {Array.from({ length:5 }).map((_,i)=> (
        <svg key={i} width="18" height="18" viewBox="0 0 24 24" fill={i < n ? '#F59E0B' : 'none'} stroke="#F59E0B"><path strokeWidth="1.5" d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.62L12 2 9.19 8.62 2 9.24l5.46 4.73L5.82 21z"/></svg>
      ))}
    </div>
  );
}

export default function Reviews(){
  return (
    <section className="container py-16">
      <div className="max-w-2xl">
        <h1 className="text-4xl md:text-5xl font-bold">What travelers say</h1>
        <p className="text-gray-600 mt-2">Real reviews from people who explored with us. Plan, book, and embark confidently.</p>
      </div>

      <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {REVIEWS.map((r, idx) => (
          <div key={idx} className="card p-6 hover:shadow-md transition group">
            <div className="flex items-center gap-3">
              <img src={r.avatar} alt={r.name} className="h-12 w-12 rounded-full object-cover"/>
              <div>
                <div className="font-semibold text-gray-900">{r.name}</div>
                <div className="text-xs text-gray-500">{r.country}</div>
              </div>
            </div>
            <div className="mt-3"><Stars n={r.rating} /></div>
            <p className="mt-3 text-gray-700 leading-relaxed">“{r.text}”</p>
            <div className="mt-4 text-xs text-gray-400">Verified Traveler</div>
          </div>
        ))}
      </div>
    </section>
  );
}
